import React from 'react';
import {
    Box,
    Center,
    Heading,
    VStack,
    Icon,
    Text,
    Button
} from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

export default function UnauthorizedPage() {
    const navigate = useNavigate();
    return (
        <Box w="100vw" h="100vh" bg="gray.50">
            <Center h="100%">
                <VStack spacing={6}>
                    <Icon as={LockIcon} boxSize={20} color="red.500" />
                    <Heading as="h1" size="2xl" color="gray.700" textAlign="center">
                        You are not authorized
                    </Heading>
                    <Text fontSize="lg" color="gray.500">
                        Please contact your administrator for access.
                    </Text>
                    <Button
                        colorScheme="teal"
                        variant="outline"
                        onClick={() => navigate(-1)}
                    >
                        BACK
                </Button>
                </VStack>
            </Center>
        </Box>
    );
}
